import { AxiosInstance } from "axios";
import { GroupeImport, GroupeImportPayload } from "../types/GroupeImport";

export const GroupeImportService = {
  createForFenetre: async (
    api: AxiosInstance,
    idFenetre: number,
    datas: Record<string, any>[]
  ): Promise<GroupeImportPayload> => {
    try {
      const response = await api.post(
        `/groupe-import/fenetre/${idFenetre}`,
        datas
      );

      return response.data;
    } catch (error: any) {
      console.error("Erreur création groupe import (fenetre):", error);

      if (error.response?.data) {
        throw new Error(error.response.data);
      }
      throw error;
    }
  },

  createForSousFenetre: async (
    api: AxiosInstance,
    idSousFenetre: number,
    datas: Record<string, any>[]
  ): Promise<GroupeImportPayload> => {
    try {
      const response = await api.post(
        `/groupe-import/sous-fenetre/${idSousFenetre}`,
        datas
      );

      return response.data;
    } catch (error: any) {
      console.error("Erreur création groupe import (sous-fenetre):", error);

      if (error.response?.data) {
        throw new Error(error.response.data);
      }
      throw error;
    }
  },

  getAll: async (api: AxiosInstance): Promise<GroupeImport[]> => {
    try {
      const response = await api.get("/groupe-import");
      return response.data as GroupeImport[];
    } catch (error) {
      console.error("Erreur lors de la récupération des groupes d'import :", error);
      throw error;
    }
  },

  getById: async (api: AxiosInstance, id: number): Promise<GroupeImport> => {
    try {
      const response = await api.get(`/api/groupe-import/${id}`);
      return response.data as GroupeImport;
    } catch (error) {
      console.error(`Erreur lors de la récupération du groupe d'import ${id}:`, error);
      throw error;
    }
  },

  getDatasForGroupImport: async (
  api: AxiosInstance,
  idGroupeImport: number
  ): Promise<Record<string, any>[]> => {
    try {
      const response = await api.get(
        `/groupe-import/${idGroupeImport}/datas`
      );
      return response.data as Record<string, any>[];
    } catch (error) {
      console.error(
        `Erreur lors de la récupération des données du groupe import ${idGroupeImport}:`,
        error
      );
      throw error;
    }
  },

  validerGroupeImport: async (api: AxiosInstance, idGroupeImport: number): Promise<void> => {
    try {
      await api.post(`/groupe-import/valider/${idGroupeImport}`);
    } catch (error: any) {
      console.error(`Erreur lors de la validation du groupe import ${idGroupeImport}:`, error);
      throw error;
    }
  },

  rejeterGroupeImport: async (api: AxiosInstance, idGroupeImport: number): Promise<void> => {
    try {
      await api.post(`/groupe-import/rejeter/${idGroupeImport}`);
    } catch (error: any) {
      console.error(`Erreur lors du rejet du groupe import ${idGroupeImport}:`, error);
      throw error;
    }
  },
};